import React from "react"

const Slider = ({ children }) => {
  return <div className="px-4 md:px-8 xl:px-24">{children}</div>
}

export default Slider
